import { css } from '@microsoft/fast-element'
import { getToken } from '../design-tokens';

export const ambientShadow = css.partial`0 0 calc((var(--elevation) * 0.225px) + 2px) rgba(0, 0, 0, calc(.11 * (2 - ${getToken('color-base-layer-luminance')})))`;
export const directionalShadow = css.partial`0 calc(var(--elevation) * 0.4px) calc((var(--elevation) * 0.9px)) rgba(0, 0, 0, calc(.13 * (2 - ${getToken('color-base-layer-luminance')})))`;
export const elevation = css.partial`${ambientShadow}, ${directionalShadow}`;

/**
* Applies the box-shadow CSS rule set to the elevation formula.
* Control this formula with the --elevation CSS Custom Property
* by setting --elevation to a number.
*/
export const elevationRule = css.partial`box-shadow: ${elevation};`;
